<template>
  <div class="text-start">
    <!--questionAnswers-->
    <template>
      <!--drag toggle switch-->
      <v-row v-if="isEditing && questionAnswers.length > 1" justify="end">
        <v-col cols="auto">
          <div class="d-flex align-center">
            <span class="body-1 font-weight-medium textLight--text px-3">
              {{ $t("reorder") }}
            </span>

            <v-switch
              v-model="isDraggingEnabled"
              inset
              flat
              hide-details
              class="ma-0"
              style="max-width: 44px"
            />
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <draggable
            v-model="questionAnswers"
            :disabled="!isEditing || !isDraggingEnabled"
            handle=".question-handle"
            @end="onDragEnd"
          >
            <v-row
              v-for="(questionAnswer, questionAnswerIndex) in questionAnswers"
              :key="`questionAnswer_${questionAnswerIndex}`"
              no-gutters
              class="mb-10"
            >
              <v-col>
                <QuizQuestionAnswer
                  :questionAnswer="questionAnswer"
                  :existingDisplayPositions="existingDisplayPositions"
                  :isEditing="isEditing && !isDraggingEnabled"
                  :selectedLocale="selectedLocale"
                  :isDraggable="isEditing && isDraggingEnabled"
                  @onUpdate="
                    updatedQuestionAnswer =>
                      updateQuizContentQuestionAnswers({
                        updatedQuestionAnswer,
                        questionAnswerIndex,
                      })
                  "
                  @onDelete="
                    updateQuizContentQuestionAnswers({
                      updatedQuestionAnswer: 'DELETE',
                      questionAnswerIndex,
                    })
                  "
                />
              </v-col>
            </v-row>
          </draggable>
        </v-col>
      </v-row>
    </template>

    <!--questionAnswer add button-->
    <v-row v-if="isEditing && !isDraggingEnabled" no-gutters class="mt-12">
      <v-col>
        <v-btn
          depressed
          block
          color="button"
          class="
            subtitle-1
            font-weight-regular
            textLight--text
            text-capitalize
            rounded-lg
          "
          @click="addQuestionAnswer"
        >
          <v-icon left size="20">mdi-plus</v-icon>

          {{ $t("course.courseDetails.addNewQuestion") }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import QuizQuestionAnswer from "@/app/quiz-module/components/details/QuizQuestionAnswer";

export default {
  name: "QuizQuestionAnswerList",
  components: {
    draggable,
    QuizQuestionAnswer,
  },
  props: {
    quizContent: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      required: true,
    },
    selectedLocale: {
      type: String,
      default: "en",
    },
  },
  data() {
    return {
      questionAnswers: [],
      isDraggingEnabled: false,
    };
  },
  computed: {
    quiz() {
      return this.quizContent.quiz ? { ...this.quizContent.quiz } : {};
    },
    existingDisplayPositions() {
      return (
        this.questionAnswers?.reduce((result, item) => {
          if (item.displayPosition != null) {
            result.push(item.displayPosition);
          }

          return result;
        }, []) ?? []
      );
    },
  },
  watch: {
    quiz: {
      handler() {
        this.questionAnswers = this.quiz?.questionAnswers ?? [];
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    emitUpdateQuizContent(updateObject) {
      this.$emit("update:quizContent", { ...this.quizContent, ...updateObject });
    },
    addQuestionAnswer() {
      this.questionAnswers.push({
        choices: [...Array(4).keys()].map(x => ({
          key: (x + 1).toString(),
          hasInvalidChoice: true,
        })),
        // displayPosition: this.questionAnswers.length,//removed for dragging
        hasInvalidQuestion: true,
        hasInvalidChoices: true,
      });

      this.emitUpdateQuizContent({
        quiz: {
          ...this.quiz,
          questionAnswers: this.questionAnswers,
        },
        hasChangesInQuiz: true,
      });
    },
    updateQuizContentQuestionAnswers({
      updatedQuestionAnswer,
      questionAnswerIndex,
    }) {
      if (updatedQuestionAnswer === "DELETE") {
        this.$dialog
          .confirm(
            this.$t(
              "course.courseDetails.confirmQuizContentQuestionDelete"
            )
          )
          .then(() => {
            this.questionAnswers.splice(questionAnswerIndex, 1);
          })
          .catch(_ => {});
      } else {
        updatedQuestionAnswer.choices?.forEach(ch => {
          ch.hasInvalidChoice = !ch.value?.find(x => x.value?.trim()?.length);
        });

        this.$set(this.questionAnswers, questionAnswerIndex, {
          ...updatedQuestionAnswer,
          hasInvalidQuestion: !updatedQuestionAnswer?.question?.find(
            x => x.value?.trim()?.length
          ),
          hasInvalidChoices: updatedQuestionAnswer?.choices?.some(
            ch => ch.hasInvalidChoice
          ),
        });
      }

      this.emitUpdateQuizContent({
        quiz: {
          ...this.quiz,
          questionAnswers: this.questionAnswers,
        },
        hasChangesInQuiz: true,
      });
    },
    onDragEnd(_) {
      this.emitUpdateQuizContent({
        quiz: {
          ...this.quiz,
          questionAnswers: this.questionAnswers,
        },
        hasChangesInQuiz: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped />
